import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {Item} from '../../models/Item';

// const toolsUrl = '/configs/Tools.ts';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  private additionalParams = {};

  get itemsMapping(): any {
    if (!(window as any).itemsMapping) {
      (window as any).itemsMapping = {};
    }
    return (window as any).itemsMapping;
  }

  set itemsMapping(value: any) {
    (window as any).itemsMapping = value;
  }

  private toolsList: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public flatToolList = {};
  private allowedCategories = [
    'sign', 'dots', 'routes', 'assets', 'infrastructure', 'ue4',
    'signage', 'routes & wayfinding', 'event infrastructure', 'carpets/trackway'
  ];

  public toolListChanges: Observable<any> = new Observable<any>((observer)=>{
    this.toolsList.subscribe(() => {
      observer.next(true);
    })
  });

  constructor(private http: HttpClient) {
    this.updateTools();
  }

  private updateToolListByCurrentItem(item){
    if (item.hasOwnProperty('items')){
        for (let i in item.items){
          let newItem = item.items[i];
          this.updateToolListByCurrentItem(newItem);
        }
    }
    else{
      this.flatToolList[item.id] = item;
    }
  }

  public getToolListByType(type): any[]{
    console.log('toollist', this.flatToolList, type);
    return Object.values(this.flatToolList).filter((element:any)=>{
      return (!type || element.type === type);
    }).sort((a:any,b:any)=>{
      if (a.name.toString().toLowerCase() < b.name.toString().toLowerCase()){
        return -1;
      }
        return 1;
    });

  }

  public updateFlatToolList() {
      let list = this.toolsList.getValue();
      // prepare flat list of all tools
      for (var i in list) {
        this.updateToolListByCurrentItem(list[i]);
      }

    }

    getCategoryImageByItem(item:Item){
    let result = null;
    if (!item || !item.config){
      return null;
    }
    let tool = item.config.getTool();
      if (tool && tool.category && tool.category.menu_icon){
        result = tool.category.menu_icon
      }
      return result;
    }

    getToolsInCategory(category){
      let list = [];
      if (category && Object.keys(category).length > 0){
        list = Object.values(this.flatToolList).filter((tool:any)=>{
          return category.id == tool.category.id;
        });
      }
      return list;
    }

  public getTools(){
    return this.toolsList.getValue();
  }

  public getToolById(id){
    if (!this.flatToolList[id].addItemMapping) {
      this.assignMappings(this.flatToolList[id]);
    }
    return this.flatToolList[id];
  }

  public getNextToolById(id){
    console.log('this.flatToolList', this.flatToolList);
    console.log('this.toolsList', this.toolsList);
  }

  assignMappings = (tool) => {
    tool.addItemMapping = (itemId, entityId) => {
      this.itemsMapping[entityId] = itemId;
    };
    tool.getItemMapping = () => {
      return this.itemsMapping;
    };
    tool.setAdditionalObject = (itemId, objectKey, object) => {
      if (!this.additionalParams[objectKey]) {
        this.additionalParams[objectKey] = {};
      }
      this.additionalParams[objectKey][itemId] = {...this.additionalParams[objectKey][itemId], ...object};
    };
    tool.getAdditionalObject = (itemId, objectKey) => {
      return this.additionalParams[objectKey] ? this.additionalParams[objectKey][itemId] : null;
    };
  }

  private filterToolList(tools) {
    const tmpTools = Object.assign({}, tools);
    for (const i in tools) {
      if (tools.hasOwnProperty(i)) {
        const toolObj = tools[i];
        if (!toolObj.hasOwnProperty('items') && toolObj.hasOwnProperty('category')) {
          this.assignMappings(toolObj);
          continue;
        }
        Object.keys(toolObj.items).forEach((key) => {
          this.assignMappings(tools[i].items[key]);
        });
      }
      // if (!tools.hasOwnProperty(i) || this.allowedCategories.indexOf(tools[i].category.name.toLowerCase()) < 0){
      //   delete tmpTools[i];
      // }
    }
    return tmpTools;
  }

  public updateTools(){
    let tools = window['TOOLS'];
    let currentTools = this.filterToolList(tools);
    console.log('currentTools', currentTools);
    this.toolsList.next(currentTools);
    this.updateFlatToolList();

    // this.http.get(toolsUrl).subscribe((tools)=>{
    //
    // })

  }

  public canUseToolById(tool) : boolean {
    return !!tool;
    // return (tool && this.allowedCategories.indexOf(tool.category.name.toLowerCase()) >= 0);
  }

}
